<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start">
                <strong >تنظیمات</strong>
              </CCol>

              <CCol col="4" style="text-align: end">
                <CButton  @click="insert_data()"
                         type="submit" size="sm" class="mr-1 ml-1"  color="secondary">
                  ثبت تنظیمات
                </CButton>

              </CCol>
            </CRow>
          </CCardHeader>
          <CRow>

            <CCol col="12">
              <CCardBody>
                <CRow>
                  <CCol col="3" v-for="setting in settings.filter(x=>x.setting_status=='visible')" :key="setting.id">
                      <CInput
                          v-if="setting.setting_type=='string'"
                          :label="setting.setting_name"
                          v-model="setting.setting_value"
                      />
                    <CInputCurrency
                          v-if="setting.setting_type=='currency'"
                          :label="setting.setting_name"
                          v-model="setting.setting_value"
                      />

                  </CCol>

                </CRow>
              </CCardBody>

            </CCol>

          </CRow>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name: "confirm_brand" + new Date().getTime() + "_" + this.$vnode.tag,
     settings:[],
      collapseDuration: 0,
      status_form: 0
    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    this.get_lists();

  }, watch: {

  },
  methods: {

    get_lists() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('/get_settings',formData, {}).then(function (response) {

        var content_data = response.data;
self.settings = response.data;

      })
          .catch(function (error) {

            console.log(error);
          });

    },


    insert_data() {

      let self = this;
      const formData = new FormData();
      let url = "update_settings";
     this.settings.forEach(function (val){
       formData.append(val.setting_key, val.setting_value);

     })

      axios.post(url, formData, {}).then((res) => {

        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {
            console.log(error);
          });

    },

  }
}

</script>
